import React from 'react';

import store from '../__doNotModify/store';
import { Provider } from 'react-redux';
import { TranslationProvider } from '../localization';
import { RootProvider } from './RootContext';

const ProvidersWrapper = ({ children }) => {
  return (
    <Provider store={store}>
      <RootProvider>
        <TranslationProvider>{children}</TranslationProvider>
      </RootProvider>
    </Provider>
  );
};

export default ProvidersWrapper;
